export const documentViewerModalStyles = {
  paper: {
    bgcolor: 'black',
    margin: 0,
    maxHeight: '100vh',
    maxWidth: '100vw',
  },
  root: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    bgcolor: 'black',
  },
  closeButton: {
    position: 'absolute',
    top: 24,
    right: 24,
    width: 40,
    height: 40,
    bgcolor: '#fafafa',
    border: '0.672px solid rgba(0,0,0,0.23)',
    '&:hover': {
      bgcolor: '#f0f0f0',
    },
  },
  closeIcon: {
    color: 'rgba(0,0,0,0.56)',
    fontSize: 20,
  },
  imageContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '99%',
    height: '178',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' as const,
  },
  verifyWrap: {
    position: 'absolute',
    bottom: 32,
    left: 0,
    right: 0,
    px: 2,
  },
  verifyButton: {
    bgcolor: '#007cbf',
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      bgcolor: '#006aa8',
    },
  },
  verifyText: {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: '"Helvetica Neue"',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px',
  },
};